import { render } from "./InflationRate.vue?vue&type=template&id=1cdaf605"
import script from "./InflationRate.vue?vue&type=script&lang=js"
export * from "./InflationRate.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__